export const AI_STANDARD_LABEL = 'AI Standard';
export const AI_ADVANCED_LABEL = 'AI Avanzata';
